export default __webpack_public_path__ + "static/media/5t.5b0fffda.jpg";